module.exports = __webpack_public_path__ + "static/media/15.103.c26d5547.jpg";